module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "out"
  }, [_c('pre', {
    staticClass: "out__text",
    style: ({
      color: _vm.theme.accent
    })
  }, [_vm._v("  Tot ce v-am spus aici cu lacrimi\n  e adevăr curat şi greu\n  mărturisit pe conştiinţă\n  şi-n Numele lui Dumnezeu\n\n  Nu-mi lepădaţi nici o frîntură\n  din tot ce spun acum şi scriu\n  că tot ce nu-nţelegeţi astăzi\n  o să-nţelegeţi mai tîrziu.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "out-next",
    on: {
      "click": _vm.goBack
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "fill": _vm.theme.icon2,
      "height": "24",
      "width": "24"
    }
  }, [_c('use', {
    attrs: {
      "href": "#iconNext"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd867ae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Beginning.vue
// module id = 130
// module chunks = 1